export default {
  edgeComputingSection: {
    intro: {
      fr: "Dites bonjour au ",
      en: "Step into the world of ",
    },
    title: {
      fr: "Edge Computing.",
      en: "Edge Computing.",
    },
    subtitle: {
      fr: "Evolutif, interopérable et pensé pour durer.",
      en: "Scalable, interoperable, and built to last.",
    },
    description: {
      fr: "Le Edge Computing place la puissance de traitement directement au coeur de l’installation, plutôt que dans le cloud. Notre technologie garantit des performances rapides, une plus grande sécurité des données et une autonomie inégalée.",
      en: "Edge computing brings processing power directly to the heart of the installation, rather than relying on the cloud. Our technology delivers fast performance, enhanced data security, and unmatched autonomy.",
    },
    features: {
      feature1: {
        title: {
          fr: "Fonctionne sans Internet",
          en: "Works even offline",
        },
        description: {
          fr: "Indépendant du cloud, votre Edge Computer\ncontinue de fonctionner même sans Internet.",
          en: "Cloud-independent by design, your Edge Computer\nkeeps working even when the Internet goes down.",
        },
      },
      feature2: {
        title: {
          fr: "L'inteligence en local, plus rapide",
          en: "Faster local intelligence",
        },
        description: {
          fr: "Des services auto-apprenants pour répondre aux\nproblématiques locales et sans latence.",
          en: "Self-learning services that adapt locally\nand respond instantly, with no latency.",
        },
      },
      feature3: {
        title: {
          fr: "Vos données, chez vous",
          en: "Your data stays with you",
        },
        description: {
          fr: "Conserve vos données en local.",
          en: "All your data is kept locally, under your control.",
        },
      },
      feature4: {
        title: {
          fr: "Des mises à jour en continu",
          en: "Continuous updates",
        },
        description: {
          fr: "Sans interruption de services, de nouvelles fonctionnalités viennent à vous en temps réel.",
          en: "New features arrive instantly, without ever interrupting your services.",
        },
      },
      feature5: {
        title: {
          fr: "Interopérable",
          en: "Interoperable",
        },
        description: {
          fr: "Compatible avec de nombreux équipements du marché: Zigbee et Matter ready.",
          en: "Compatible with a wide range of devices. Zigbee and Matter ready.",
        },
      },
      feature6: {
        title: {
          fr: "Un système qui ne s'arrête jamais",
          en: "A system that never stops",
        },
        description: {
          fr: "Connexions simultanées Ethernet & clé 4G WiFi. Alimentations simultanées 230V & batterie USB-C.",
          en: "Redundant connectivity with Ethernet and 4G Wi-Fi, plus dual power sources: 230V and USB-C battery.",
        },
      },
    },
  },
};
